import mainCaller from './mainCaller';

export const getExpireDateActiveMember = async (branchId, baseDate, token) => {
  return await mainCaller(
    `admin/api/v1/members/expire-date/active-member-ids?branchId=${branchId}&baseDate=${baseDate}`,
    'GET',
    null,
    {
      Authorization: `Bearer ${token}`,
    },
  );
};

// 지점별 만료임박 기준 조회 (수강권/이용권/라커)
export const getExpirationAlerts = async (branchId, token) => {
  return await mainCaller(`admin/api/v2/branches/${branchId}/expiration-alerts`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

// 지점별 만료임박 기준 수정 (PATCH — 전달한 필드만 업데이트)
export const updateExpirationAlerts = async (branchId, payload, token) => {
  return await mainCaller(`admin/api/v2/branches/${branchId}/expiration-alerts`, 'PATCH', payload, {
    Authorization: `Bearer ${token}`,
  });
};
